export const getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    // Creating inner element and placing it in the container
    const inner = document.createElement("div");
    outer.appendChild(inner);
    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    // Removing temporary elements from the DOM
    outer.parentNode?.removeChild(outer);
    return scrollbarWidth;
};
export const scrollBarWidth = getScrollbarWidth();
const canvas = document.createElement("canvas");
export const getTextWidth = (text, fontSize = "13px", fontFamily = "Roboto, sans-serif", fontWeight = "400", fontStyle = "normal", fontVariant = "normal") => {
    const context = canvas.getContext("2d");
    context.font = `${fontStyle} ${fontVariant} ${fontWeight} ${fontSize} ${fontFamily}`;
    const metrics = context.measureText(text);
    return metrics.width;
};
